import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { InputField, required, email } from '../components/form';
import { Blank as Layout } from '../components/layouts';
import { SessionApi } from '../api';
import { setLoader, removeLoader } from '../actions';

class ForgotPassword extends Component {

  componentWillMount() {
    const { isAuthenticated, dispatch, redirectTo } = this.props;
    if (isAuthenticated) dispatch(push(redirectTo));
  }

  onFormSubmit(values) {
    const { dispatch, isPublisher, isAdvertiser } = this.props;
    dispatch(setLoader('ForgotPasswordForm'));
    const platform = isPublisher ? 'Publisher' : (isAdvertiser ? 'Advertiser' : '');
    dispatch(SessionApi.actions.forgotPassword.post({ ...values, platform }, () => {
      dispatch(removeLoader('ForgotPasswordForm'));
    }));
  }

  render() {
    const { handleSubmit, isPublisher, isAdvertiser } = this.props;
    const platform = isPublisher ? 'publisher' : 'advertiser';
    const otherPlatform = isAdvertiser ? 'publisher' : 'advertiser';
    return (
      <Layout>

        <div className='middle-box text-center loginscreen animated fadeIn'>
            <div>
                <div>
                    <h1 className='logo-name'>JobAdX</h1>
                </div>

                <h3 style={{ textTransform: 'capitalize' }}>
                  {platform} platform
                </h3>

                <p>Please enter email</p>

                <form
                  onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
                  className='m-t text-right'
                >
                  <Field
                    type='text'
                    name='user[email]'
                    placeholder='Email'
                    component={InputField}
                    validate={[required, email]}
                  />

                  <Field name="user[country_code]" component="select" placeholder='Country Code' className="form-control m-b">
                    <option value='US'>US</option>
                    <option value='CA'>CA</option>
                  </Field>
                  
                  <Button
                    type='submit'
                    loading={this.props.isLoading}
                    bsStyle='primary'
                    className='block full-width m-b'
                  >
                    Reset Password
                  </Button>

                  <div className='text-center'>
                    <Link to={`/${platform}`}>
                      <small>
                          Go back
                      </small>
                    </Link>

                    <br />
                    <Link to={`/${otherPlatform}/forgotpassword`}>
                      <small>
                          Reset {`${otherPlatform}`} password
                      </small>
                    </Link>
                  </div>
                </form>
            </div>
        </div>
      </Layout>
    );
  }
}

const form = reduxForm({
  form: 'ForgotPasswordForm'
});

const mapStateToProps = (state, ownProps) => {
  const { location: { pathname } } = ownProps;
  const { loader, auth: { data: { isAuthenticated } } } = state;
  const isLoading = loader.includes('ForgotPasswordForm');

  return {
    isAuthenticated,
    isLoading,
    redirectTo: '/initializing',
    isPublisher: pathname.match(/publisher/i),
    isAdvertiser: pathname.match(/advertiser/i)
  };
};

export default connect(mapStateToProps)(form(ForgotPassword));
